export default {
  title: 'Default Header',
  layout: 'nav-right',
  layoutMobile: 'logo-left-nav-left',
  width: 'wide',
  enabled: false,
  disabledPageIds: [],
  sticky: false,
  textLogo: 'Text Logo',
  logoAction: {type: 'none'},
  logo: '',
  logoTransparent: '',
  buttonPrimary: {
    displayOn: [],
    enabled: {
      desktop: true,
    },
    text: 'Button Text',
    subtext: '',
    action: {},
  },
  buttonSecondary: {
    enabled: {
      desktop: false,
    },
    text: 'Button Text',
    subtext: '',
    action: {},
  },
  items: [],
  transparent: {
    defaultHeader: 'standard', // ['standard', 'transparent']
    standardPageIds: [],
    transparentPageIds: [],
  },
  topbar: {
    enabled: true,
    sticky: false,
    content: 'Your topbar announcement text',
  },
};
